import { Injectable } from '@angular/core';
import { AuthHttp, tokenNotExpired } from 'angular2-jwt/angular2-jwt';
import { UtilsService } from './utils.service';
import { Router } from '@angular/router';
import { ArcService } from './arc.service'
import { ProjectService } from './project.service'

declare var Auth0Lock: any;

@Injectable()
export class AuthService {

  private _isAdmin = undefined;
  private _email = undefined;
  private _prepared = false;


  lock = new Auth0Lock('a8KTsZZ3pCoFIOGghCP7QWvk8ZlVxz3a',
    'nicmila.eu.auth0.com',
    { auth: { redirect: false } });


  constructor(
    private utils: UtilsService,
    private router: Router,
    private arcs: ArcService,
    private projects: ProjectService
  ) {
    this.utils.auths = this
    this.lock.on("authenticated", (authResult) => {

      this.lock.getUserInfo(authResult.accessToken, (error, profile) => {
        if (error) {
          // Handle error
          alert(error);
          return;
        }
        localStorage.setItem('auth_profile', JSON.stringify(profile));
        localStorage.setItem('accessToken', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        //localStorage.setItem('idToken', authResult.idToken);
        this.prepare();
        //  this.router.navigate(['flowers','list'])
      }, (err) => { console.log("AUTH ERROR", err) });
    })
  }

  prepare() {
    if (this._prepared)
      return
    this._prepared = true
    this.utils.uniqueIdentifier
    this.utils.auths = this
    this.projects.init()
  }

  login() {
    // Call the show method to display the widget.
    this.lock.show();
  };

  get email() {
    if (this._email === undefined) {
      const authProf = localStorage.getItem('auth_profile');
      if (!authProf) {
        return undefined;
      }
      this._email = JSON.parse(authProf)['email'];
    }
    return this._email
  }

  get isAdmin() {
    if (this._isAdmin === undefined)
      this._isAdmin = new Set(
        [
          'nicmila@gmail.com',
          'kdibusz@gmail.com',
          'tomasnovotnyrs@gmail.com',
          'beda@ecomole.com'
        ]).has(this.email)
    return this._isAdmin
  }

  get authenticated() {
    let state = tokenNotExpired('id_token');
    if (state)
      this.prepare()
    return state
  };

  logout() {
    // Remove token from localStorage
    localStorage.removeItem('auth_profile');
    localStorage.removeItem('id_token');
    location.reload()
  };


}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/auth.service.ts